

const TabContent = (props) => {
    return (
      <div>
       {props.children}
      </div>
    );
  }
  
  export default TabContent;